import { RuleCriteria } from '@/alert/components/alertDetail/alertDetail.types';
import { CHECK_BY_COMBINATION, EVENT_TYPE_ENUM } from '@/alert/utils/define';
import { AlertValueViewType } from '@/alert/components/alertGrid/alertGrid.types';

// alert value가 공백이 아니고 숫자 타입 데이터도 아니면(텍스트 값) Alert Value 모달로 노출한다.
// (프로세스 상태 감지 등 BE가 완성한 텍스트 value를 eventType과 무관하게 처리)
const isNonNumericAlertValue = (value?: string): boolean => {
  const trimmed = `${value ?? ''}`.trim();
  if (!trimmed) {
    return false;
  }
  return Number.isNaN(Number(trimmed));
};

export const getRuleNameIcon = ({ ruleCriteria }: { ruleCriteria: RuleCriteria }) =>
  ruleCriteria === CHECK_BY_COMBINATION
    ? 'icon-alert-check-by-combination'
    : 'icon-alert-check-by-target';

const isValidJsonString = (value: any): boolean => {
  if (typeof value !== 'string') {
    return false;
  }

  if (value.trim() === '') {
    return false;
  }
  try {
    const parsed = JSON.parse(value);
    return typeof parsed === 'object' && parsed !== null && !Array.isArray(parsed);
  } catch {
    return false;
  }
};

/**
 * Alert Value 셀을 어떤 형태로 출력할지 결정한다.
 * 호출부가 후보를 하나씩 물어보면 판정 우선순위가 호출 순서에 숨어버리므로,
 * 결과 타입을 직접 반환해 한 행이 항상 하나의 형태로만 해석되도록 한다.
 *
 * - `'logging'`: 로그 알람 JSON → message 파싱 후 출력
 * - `'text'`: 텍스트 value → 모달 링크로 출력
 * - `null`: 숫자 등 일반 value → 그대로 출력
 */
export const resolveAlertValueViewType = (
  rowData: Record<string, any>,
): AlertValueViewType | null => {
  const { eventType, value = '' } = rowData ?? {};

  if (eventType === EVENT_TYPE_ENUM.LOGGING && isValidJsonString(value)) {
    return 'logging';
  }

  const isTextValue =
    [EVENT_TYPE_ENUM.KUBERNETES, EVENT_TYPE_ENUM.HOST, EVENT_TYPE_ENUM.APPLICATION].includes(
      eventType ?? '',
    ) || isNonNumericAlertValue(value);

  return isTextValue ? 'text' : null;
};
